module.exports = __webpack_public_path__ + "images/0349f816257ba5490ee1050824bef273.webp";